import { render } from "./tradeChart.vue?vue&type=template&id=2fb3bbc3"
import script from "./tradeChart.vue?vue&type=script&lang=js"
export * from "./tradeChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__